import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, requirePro = false, requireRole = null }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-[60vh] grid place-items-center">
        <Loader2 className="w-7 h-7 text-[#1E3A8A] animate-spin" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (requireRole && user.role !== requireRole) {
    return <Navigate to="/cuenta" replace />;
  }
  if (requirePro && !user.es_pro) {
    return <Navigate to="/cuenta" replace />;
  }
  return children;
}
